























// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";

export default defineComponent({

	emits:[],
	props:{
		value:{
			type:String,
		},
	},
	components:{
	},
	setup(){
		
		const options = [
			{
				value:"en",
				text:"English",
			},
			{
				value:"is",
				text:"Icelandic",
			},
		];

		return {
			options,
		};
	}
});

